var animate_type = 'up'; //up or left or fadeout
var sec = 0.3; //0.5秒
var nav_box_setting = ['.cell_nav_box', '.cell_nav_open_btn', '.cell_nav_close_btn', animate_type, sec];
var nav_box_offset
var obj
var obj_close
var check
var move


$().ready(function() {
  nav_box(nav_box_setting);
  $(' #da-thumbs > li ').each(function() { $(this).hoverdir(); });
});

var cx = '005583908390302854516:faepp2qgog8';
var gcse = document.createElement('script');
gcse.type = 'text/javascript';
gcse.async = true;
gcse.src = 'https://cse.google.com/cse.js?cx=' + cx;
var s = document.getElementsByTagName('script')[0];
s.parentNode.insertBefore(gcse, s);

function nav_box(nav_box_setting, animate) {
  nav_box_offset = 20;
  if (!nav_box_setting) return;

  obj = $(nav_box_setting[0]);
  obj_close = $(nav_box_setting[0]);
  animate_type = nav_box_setting[3];
  sec = nav_box_setting[4] * 1000;

  if (animate != 'Y') {
    if (animate_type == 'left') $(nav_box_setting[0]).css({ 'position': 'fixed', 'left': ($(this).width() * -1 - nav_box_offset) });
    if (animate_type == 'up') $(nav_box_setting[0]).css({ 'position': 'fixed', 'top': $(this).height() * -1 - nav_box_offset });
    if (animate_type == 'fadeout') $(nav_box_setting[0]).css({ 'position': 'fixed' }).hide();
    $(nav_box_setting[1]).on('click', function() { nav_box(nav_box_setting, 'Y') });
    $(nav_box_setting[2]).on('click', function() { nav_box(nav_box_setting, 'Y') });
    $('.clicknav').on('click', function() { nav_box(nav_box_setting, 'Y') });
    return;
  }

  check = false;
  if (animate_type == 'left' && parseInt(obj.css('left')) < 0) check = true;
  if (animate_type == 'up' && parseInt(obj.css('top')) < 0) check = true;
  if (animate_type == 'fadeout' && obj.css('display') == 'none') check = true;

  if (check) {
    //OPEN鈕效果
    //$(nav_box_setting[1]).hide();
    if (animate_type == 'left') obj.animate({ left: 0 }, sec);
    if (animate_type == 'up') obj.animate({ top: 84 }, sec);
    if (animate_type == 'fadeout') obj.fadeIn(sec);
  } else {
    if (animate_type == 'left') {
      move = obj.width() + nav_box_offset;
      obj.animate({ left: move * -1 }, sec);
    }

    if (animate_type == 'up') {
      move = obj.height() + nav_box_offset;
      obj.animate({ top: move * -1 }, sec);
    }
    if (animate_type == 'fadeout') obj.fadeOut(sec);

    //OPEN鈕效果
    //setTimeout(function(){$(nav_box_setting[1]).show();},sec);
  }
}

// $(function() {
//   SyntaxHighlighter.all();
// });

export default { //export your file
  init: function() {
    $('.clone').remove()
    $('.flexslider').flexslider({
      animation: "slide",
    });
    $('#carousel-example-generic').carousel({
      interval: 4000
    });

  },
  destroy: function() {
    $('.clone').remove()
  },
  test: function() {
    nav_box(nav_box_setting);
  }
}
$(window).on('load', function() {
  $('.flexslider').flexslider({
    animation: "slide",
    start: function(slider) {
      $('body').removeClass('loading');
    }
  });
})
// 若在mounted使用init()輪播圖片大小有變成超大的可能
//　所以額外使用load



//////////////////
// WEBPACK FOOTER
// ./static/js/home.js
// module id = 1329
// module chunks = 4